export const auth = {
  login: "Login",
  email: "Email Address",
  password: "Password",
  rememberMe: "Remember me",
  emailPlaceholder: "Enter email address",
  passwordPlaceholder: "Enter password",
  validations: {
    emailReq: "Email is required",
    emailValid: "Please enter a valid email",
    passwordReq: "Password is required",
    req: "Required",
    confirmPasswordRequired: "Confirm Password is required",
    passowrdCriteria:
      "Password should contain at least 10 characters, mix of letters (upper and lower case), numbers, and special characters",
    passwordsMustMatch: "Password and Confirm Password must match",
  },
  activateAccount: {
    accountActivation: "Account activation",
    password: "Password",
    confirmPassword: "Confirm Password",
    passwordPlaceholder: "Enter password",
    confirmPasswordPlaceholder: "Enter confirm password",
    activate: "Activate",
    goToLogin: "Go to Login",
  },
  resetPassword: {
    resetPassword: "Reset Password",
    reset: "Reset"
  },
  messages: {
    activateAccount: "Your account was activated succeessfully",
    resetPassword: "Password was reset successfully",
  },
};
